import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {PlayerLevelReportV2DownloadClientStrategy, PlayerLevelReportV2DownloadServerStrategy} from './downloadStrategy';
import {PlayerLevelReportV2Service} from './service';
import {type PlayerLevelReportV2ViewModelKeys, ServiceTypes} from './types';

export class PlayerLevelReportV2ContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(ServiceTypes.PlayerLevelReportV2Service).to(PlayerLevelReportV2Service);
        this._container
            .bind<IDownloadStrategy<PlayerLevelReportV2ViewModelKeys>>(ServiceTypes.DownloadClientStrategy)
            .to(PlayerLevelReportV2DownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<PlayerLevelReportV2ViewModelKeys>>(ServiceTypes.DownloadServerStrategy)
            .to(PlayerLevelReportV2DownloadServerStrategy);
    }
}
